<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="Work Management" title="Works" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">

							<div class="col-md-12 project-list page-subtitle">
								<div class="row">
									<div class="col-md-9">
										<router-link :to="{ name: 'create_job' }" class="btn btn-primary float-end">Create Work</router-link>
									</div>

									<div class="col-md-3">
										<router-link :to="{ name: 'generate_device_certificate' }" class="btn btn-primary float-end">Generate Device Certificate</router-link>
									</div>
								</div>
							</div>

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-4 d-flex mt-2">
										<label class="d-flex listing-length ms-1"><span>Show</span>
											<select class="form-select" v-model="listing_length" @change="fetchJobs()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
											</select>
											<span>entries</span>
										</label>
									</div>
									<div class="col-md-2 mt-2">
										<select class="form-select" v-model="product_id" @change="fetchJobs()">
											<option value="">All Products</option>
											<option value="1">Airotrack GPS</option>
											<option value="2">Camera</option>
											<option value="3">Speed Governor</option>
										</select>
									</div>
									<div class="col-md-2 mt-2">
										<select class="form-select" v-model="status" @change="fetchJobs()">
											<option value="">All</option>
											<option value="4">Enquiry</option>
                                            <option value="1">Pending</option>
											<option value="2">Ongoing</option>
                                            <option value="3">Completed</option>
										</select>
									</div>
									<div class="col-md-2 mt-2">
										<select v-if="!isDealerRole" class="form-select" v-model="payment_status" @change="fetchJobs()">
											<option value="">Payment Status</option>
                                            <option value="1">Completed</option>
											<option value="2">Pending</option>
											<option value="3">Partially Paid</option>
										</select>
									</div>
									<div class="col-md-2 mt-2">
										<input type="text" class="form-control ms-1 float-end" placeholder="Search" v-model="keyword" @keyup="fetchJobs()"/>
									</div>
								</div>
							</div>

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr align="center">
                                            <th>Sl.No</th>  
                                            <th>Customer</th>
											<th>Location</th>
											<th>Product & Work Type</th>
											<th>Technician</th>
											<th>Date</th>
											<th>Total Amount</th>
											<th>Vehicle No.</th>
                                            <th>Work Status</th>
                                            <th v-if="!isDealerRole">Payment Status</th>
											<th>Created User</th>
											<th>Options</th>
                                        </tr>
									</thead>
									<tbody v-if="Boolean(jobs.length)">
										<tr align="center" v-for="(job, index) in jobs" :key="index">
                                            <td>{{ (from - 1) + index + 1 }}</td>
											<td>
												{{ job.customer_name }}<br>
												+91 {{ job.mobile }}
											</td>
											<td>{{ job.location }}</td>
											<td>{{ job.product_name }} <br>
											 	<span v-if="job.service_type == 1">New</span>
											  	<span v-else-if="job.service_type == 2">Repair</span>
												<span v-else>Replacement</span>
											</td>
											<td>{{ job.technician_name }}</td>
											<td>{{ proxy.$filters.convertDate(job.date) }}</td>
											<td>
												<span v-if="job.total_amount != null">Rs.{{ job.total_amount }}</span>
												<span v-else></span>
											</td>
											<td>{{ job.vehicle_no }}</td>
											<td>
												<span class="badge rounded-pill bg-warning" v-if="job.job_status === 1">Pending</span>
												<span class="badge rounded-pill bg-primary" v-else-if="job.job_status === 2">Ongoing</span>
												<span class="badge rounded-pill bg-success" v-else-if="job.job_status === 3">Completed</span>
												<span class="badge rounded-pill bg-danger" v-else-if="job.job_status === 4">Requested</span>
												<span class="badge rounded-pill bg-danger" v-else-if="job.job_status === 5">Cancelled</span>
												<span class="badge rounded-pill bg-secondary" v-else-if="job.job_status === 6">Reassigned</span>
												<span class="badge rounded-pill bg-warning" v-else-if="job.job_status === 7">Pending</span>

												<br>
												<span v-if="job.job_status === 3">Valid Upto: {{ proxy.$filters.convertDate(job.valid_upto) }}</span>
												<span class="badge rounded-pill bg-info" v-if="job.renewal_status === 1">Renewed</span>
											</td>
											<td v-if="!isDealerRole">
												<span class="badge rounded-pill bg-success" v-if="job.payment_status === 1">Completed</span>
												<span class="badge rounded-pill bg-warning" v-else-if="job.payment_status === 2 || job.payment_status === null">Pending</span>
												<span class="badge rounded-pill bg-primary" v-else-if="job.payment_status === 3">Partially Paid</span>
											</td>
											<td>{{ job.added_user_name }}</td>
                                            <td>
												<!-- job_type = 2: certificate works — Update + Certificate when completed -->
												<template v-if="job.job_type == 2">
													<router-link v-if="job.job_status === 3" :to="{ name: 'update_certificate', query: { id: job.id } }" class="btn btn-success btn-sm me-2 mb-2">Update</router-link>
													<button v-if="job.job_status === 3" class="btn btn-info btn-sm me-2 mb-2" @click="generatePDF(job)" :disabled="loadingJobs.has(job.id)">
														<span v-if="loadingJobs.has(job.id)" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
														{{ loadingJobs.has(job.id) ? 'Generating...' : 'Certificate' }}
													</button>
													<button v-if="canRenew(job)" class="btn btn-dark btn-sm me-2 mb-2" @click="openRenewModal(job)">Renew Certificate</button>
												</template>
												<!-- For other job types, show all buttons -->
												<template v-else>
													<router-link :to="{ name: 'update_job', query: { id: job.id } }" class="btn btn-secondary btn-sm me-2 mb-2" v-if="job.job_status != 3 && job.job_status != 5">Edit</router-link><br>
													<router-link :to="{ name: 'job_details', query: { id: job.id } }" class="btn btn-primary btn-sm me-2 mb-2">Details</router-link>
													<router-link v-if="job.job_status === 3" :to="{ name: 'update_certificate', query: { id: job.id } }" class="btn btn-success btn-sm me-2 mb-2">Update</router-link>
													<button v-if="job.job_status === 3" class="btn btn-info btn-sm me-2 mb-2" @click="generatePDF(job)" :disabled="loadingJobs.has(job.id)">
														<span v-if="loadingJobs.has(job.id)" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
														{{ loadingJobs.has(job.id) ? 'Generating...' : 'Certificate' }}
													</button>
													<button v-if="canRenew(job)" class="btn btn-dark btn-sm me-2 mb-2" @click="openRenewModal(job)">Renew Certificate</button>
													<router-link :to="{ name: 'job_logs', query: { id: job.id } }" class="btn btn-warning btn-sm me-2 mb-2">Logs</router-link>
													<button class="btn btn-danger btn-sm me-2 mb-2" @click="deleteJob(job)" v-if="job.job_status == 1 || job.job_status == 4 || job.job_status == 7">Delete</button>
												</template>
                                            </td>
                                        </tr>
                                    </tbody>
									<tbody v-else>
										<tr>
											<td colspan="11" class="text-center">No works found</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<div class="row mt-2">
								<div class="col-md-6">
									<p class="text-muted mb-0">
										Showing {{ from || 0 }} to {{ to || 0 }} of {{ total || 0 }} entries
									</p>
								</div>
								<div class="col-md-6">
									<nav aria-label="Page navigation">
										<ul class="pagination justify-content-end">
											<li class="page-item" v-for="(page, index) in pagination" :key="index" :class="[{ disabled: !page.url }, { active: page.active }]">
												<a class="page-link" href="#" @click.prevent="fetchJobs(page.url)" tabindex="-1">
													<span v-if="index === 0">Prev</span>
													<span v-else-if="index === pagination.length - 1">Next</span>
													<span v-else v-html="page.label"></span>
												</a>
											</li>
										</ul>
									</nav>
								</div>
							</div>
							<!----pagination ends --->
							
						</div>
					</div>
				</div>
			</div>
		</div>

		<DynamicModal title="Renew Certificate">
			<template #body>
				<form @submit.prevent="renewCertificate">
					<div class="row">
						<div class="col-md-12 form-group mt-2">
							<label class="control-label">Valid Upto<span class="text-danger">*</span></label>
							<input class="form-control" type="date" v-model="validUpto" />
							<span class="validate-error" v-if="renewErrors.valid_upto">
								{{ renewErrors.valid_upto[0] }}
							</span>
						</div>
					</div>
					<div class="col-md-12 form-group mt-3">
						<button type="submit" class="btn btn-primary me-3" :disabled="renewing">
							<span v-if="renewing" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
							{{ renewing ? 'Saving...' : 'Save' }}
						</button>
						<button class="btn btn-light" type="button" @click="closeRenewModal()" :disabled="renewing">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>
	</div>
</template>

<script setup>
	import { onMounted, ref, computed, getCurrentInstance } from 'vue';
	import { useRouter } from 'vue-router';
	import { Modal } from 'bootstrap';
	import DynamicModal from '@/components/dynamic_modal.vue';
	import { routes } from '@/constants/routes';
	import { get, getFile, post } from '@/utils/api';
	import Swal from '@/utils/swal';
	import {
		DEALER_ROLE_ID,
		readStoredLoginDetails,
		parseSettingsDealerProfile,
	} from '@/utils/dealerRole3Profile';

	const router = useRouter();
	const { proxy } = getCurrentInstance();

	const jobs = ref([]);
	const listing_length = ref(10);
	const status = ref("");
	const payment_status = ref("");
	const keyword = ref("");
	const from = ref(null);
	const to = ref(null);
	const total = ref(null);
	const pagination = ref({});
	const loadingJobs = ref(new Set());
	const product_id = ref("");
	const renewJobId = ref(null);
	const validUpto = ref("");
	const renewErrors = ref({});
	const renewing = ref(false);
	let renewModal = null;

	const toDateInputValue = (value) => {
		if (!value) return "";
		const match = String(value).match(/^(\d{4}-\d{2}-\d{2})/);
		return match ? match[1] : "";
	};

	// Renew is allowed only for product 2 completed jobs whose certificate has expired (valid_upto <= today)
	const canRenew = (job) => {
		const validUptoDate = toDateInputValue(job.valid_upto);
		if (!validUptoDate) return false;
		const now = new Date();
		const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
		return job.product_id == 2 && job.job_status === 3 && validUptoDate <= today;
	};

	const openRenewModal = (job) => {
		renewErrors.value = {};
		renewJobId.value = job.id;
		validUpto.value = toDateInputValue(job.valid_upto);
		if (renewModal) renewModal.show();
	};

	const closeRenewModal = () => {
		if (renewModal) renewModal.hide();
		renewJobId.value = null;
		validUpto.value = "";
		renewErrors.value = {};
	};

	const user_role_id = ref(null);
	const isDealerRole = computed(() => Number(user_role_id.value) === DEALER_ROLE_ID);

	const fetchJobs = (url = null) => {

		const params = {
			limit: listing_length.value,
			status: status.value,
			payment_status: payment_status.value,
			keyword: keyword.value,
			product_id: product_id.value,
		}

		const requestUrl = url ?? routes.Jobs;

		get(requestUrl, { params }, false)
			.then((response) => {
				if(response.status === 200){
					console.log(response.data.data);
					jobs.value = response.data.data.jobs.data;
					pagination.value = response.data.data.jobs.links;
					from.value = response.data.data.jobs.from;
					to.value = response.data.data.jobs.to;
					total.value = response.data.data.jobs.total;
				} else {
					Swal.fire('', response.data.message || 'Failed to fetch jobs', 'error');
				}
			})
			.catch((error)	=> {
				if (error.response?.status === 422) {
					Swal.fire('', error.response.data.message.limit?.[0] || error.response.data.message.status?.[0] || error.response.data.message.payment_status?.[0] || error.response.data.message.keyword?.[0] || 'Validation error', 'error');
				} else if (error.response?.status === 500) {
					Swal.fire('', error.response.statusText || 'Server error', 'error');
				} else if (error.response?.status === 401) {
					Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
					router.push({ name: 'login' });
				} else {
					Swal.fire('', error.response.data?.message || 'Error occured', 'error');
				}
			});
	};

	const generatePDF = (job) => {
		loadingJobs.value.add(job.id);

		const params = {
			job_id: job.id,
		}

		getFile(routes.InstallationCertificate, params, false)
			.then((response) => {
				const fileURL = window.URL.createObjectURL(new Blob([response.data]));
				const fileLink = document.createElement('a');
				fileLink.href = fileURL;
				fileLink.setAttribute('download', 'InstallationCertificate_' + job.vehicle_no + '.pdf');
				document.body.appendChild(fileLink);
				fileLink.click();
				document.body.removeChild(fileLink);
				window.URL.revokeObjectURL(fileURL);
				loadingJobs.value.delete(job.id);
			})
			.catch((error) => {
				loadingJobs.value.delete(job.id);
				if (error.response?.status === 422) {
					const parseErrorBlob = async () => {
						try {
							let json = {};

							if (error.response.data instanceof Blob) {
								const text = await error.response.data.text();
								json = JSON.parse(text);
							} else {
								json = error.response.data;
							}

							const message = json.message || {};
							const firstError =
								message.limit?.[0] ||
								message.from_date?.[0] ||
								message.to_date?.[0] ||
								message.technician_id?.[0] ||
								'Validation error';

							Swal.fire('', firstError, 'error');
						} catch (e) {
							console.error('Failed to parse error blob:', e);
							Swal.fire('', 'Validation error', 'error');
						}
					};

					parseErrorBlob();            
				} else if (error.response?.status === 500) {
					Swal.fire('', error.response.statusText || 'Server error', 'error');
				} else if (error.response?.status === 401) {
					Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
					router.push({ name: 'login' });
				} else {
					Swal.fire('', error.response.data?.message || 'Error occured', 'error');
				}
			});
	};

	const deleteJob = (job) => {
		Swal.fire({
			icon: 'warning',
			title:"Confirm",
			text:'Are you sure you want to delete this job?',
			showCancelButton: true,
			confirmButtonText: 'Yes',
			confirmButtonColor: '#e64942',
			cancelButtonText: 'No',
			position: "center",
			showConfirmButton: true,
			timer: '',
			toast: false,
			cancelButtonColor: '#efefef',
				}).then((result)=>{
					if(result.value){
						updateDeleteJob(job.id);
					}
				});
	};


	const updateDeleteJob = (id) => {
		const params = {
			job_id: id,
		}

		get(routes.DeleteJob, { params }, false)
			.then((response) => {
				if (response.status === 200) {
					Swal.fire('', response.data.message || 'Job deleted successfully', 'success');
					fetchJobs();
				} else {
					Swal.fire('', response.data.message || 'Error deleting job', 'error');
				}
			})
			.catch((error) => {
				if (error.response?.status === 422) {
					Swal.fire('', error.response.data.message.job_id[0] || 'Validation error', 'error');
				} else if (error.response?.status === 500) {
					Swal.fire('', error.response.statusText || 'Server error', 'error');
				} else if (error.response?.status === 401) {
					Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
					router.push({ name: 'login' });
				} else {
					Swal.fire('', error.response.data?.message || 'Error occured', 'error');
				}
			});
	};

	const renewCertificate = () => {
		renewErrors.value = {};

		if (!validUpto.value) {
			renewErrors.value = { valid_upto: ['Please choose a valid upto date.'] };
			return;
		}

		renewing.value = true;

		const formData = new FormData();
		formData.append('job_id', renewJobId.value);
		formData.append('valid_upto', validUpto.value);

		post(routes.RenewCertificate, formData, false)
			.then((response) => {
				if (response.status === 200) {
					closeRenewModal();
					Swal.fire('', response.data.message || 'Certificate renewed successfully', 'success');
					fetchJobs();
				} else {
					Swal.fire('', response.data.message || 'Failed to renew certificate', 'error');
				}
			})
			.catch((error) => {
				if (error.response?.status === 422) {
					const message = error.response.data?.message || {};
					if (message.valid_upto || message.job_id) {
						renewErrors.value = message;
					} else {
						Swal.fire('', typeof message === 'string' ? message : 'Validation error', 'error');
					}
				} else if (error.response?.status === 500) {
					Swal.fire('', error.response.statusText || 'Server error', 'error');
				} else if (error.response?.status === 401) {
					Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
					router.push({ name: 'login' });
				} else {
					Swal.fire('', error.response?.data?.message || 'Error occured', 'error');
				}
			})
			.finally(() => {
				renewing.value = false;
			});
	};

	onMounted(() => {
		const ls = readStoredLoginDetails();
		if (ls) {
			const p = parseSettingsDealerProfile(ls);
			if (p.roleId != null) user_role_id.value = p.roleId;
		}
		renewModal = new Modal(document.getElementById('dynamicmodal'));
		fetchJobs();
	})

</script>